import React, { useContext, useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { useSelector } from 'react-redux';
import { Link,useNavigate, useLocation } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import ROLE from '../common/role';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';


const ChangePassword = () => {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordData, setPasswordData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation(); 
    const user = useSelector(state => state?.user?.user); // Get user details from redux
    const navigate = useNavigate();

    const [userDetails, setUserDetails] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.GENERAL) {
            
            navigate("/");
            setLoading(false);
          } 
          else {
            setLoading(false);
            clearTimeout(loadingTimeout)
            fetchUserDetails()
          }
        } 
    
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);



    const fetchUserDetails = async () => {
        const response = await fetch(SummaryApi.current_user.url, {
            method: SummaryApi.current_user.method,
            credentials: 'include',
            headers: {
                'content-type': 'application/json',
            },
        });
        const responseData = await response.json();
        if (responseData.success) {
            setUserDetails(responseData.data);
        }
    };






    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!passwordData.oldPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
            toast.error("من فضلك قم بكتابة جميع المتطلبات الثلاثة");
            return;
        }

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            toast.error("كلمة المرور الجديدة وتاكيد كلمة المرور الجديدة غير متطابقين");
            return;
        }

        try {
            setLoading(true);

            const response = await fetch(SummaryApi.changePassword.url, {
                method: SummaryApi.changePassword.method,
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                   
                },
                body: JSON.stringify({
                     userId: userDetails?._id,
                    ...passwordData
                })
            });

            const result = await response.json();

            if (response.ok) { // Check if response is OK
                toast.success(result.message);
                setPasswordData({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });
            } else {
                toast.error(result.message || 'فشل تغيير كلمة المرور');
            }
        } catch (error) {
            toast.error('فشل تغيير كلمة المرور');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
          <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
        );
      }

    return (
        <section id='ChangePassword'>
            <div className='min-h-[calc(100vh-120px)] lg:flex'>
                {/* Sidebar */}
                 {/* Mobile Toggle Button */}
      <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>

  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {user?.profilePic ? (
        <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{user?.name}</p>
    <p className='text-sm'>{user?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : user?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : user?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>
      {/* معلومات شخصية */}
      <div className='mb-4'>
        <h3 className='text-xl font-bold mb-2 text-center'>المعلومات الشخصية</h3>
        <Link
          to='/userProfile'
          className={`block px-2 py-1 ${location.pathname === '/userProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          الملف الشخصي
        </Link>
        <Link
          to='/userEditProfile'
          className={`block px-2 py-1 ${location.pathname === '/userEditProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تعديل الملف الشخصي
        </Link>
        <Link
          to='/changePassword'
          className={`block px-2 py-1 ${location.pathname === '/changePassword' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تغيير كلمة المرور
        </Link>
      </div>

     
    </nav>
  </div>
</aside>

                {/* Main content */}
                <main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
                    <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                        <form className='pt-6 flex flex-col gap-4 text-right' onSubmit={handleSubmit}>
                            <div>
                                <label>: كلمة المرور القديمة</label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showOldPassword ? "text" : "password"}
                                        placeholder=' ادخل كلمة المرور القديمة  '
                                        name='oldPassword'
                                        value={passwordData.oldPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowOldPassword(prev => !prev)}>
                                        {showOldPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label>: كلمة المرور الجديدة</label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        placeholder='ادخل كلمة المرور الجديدة '
                                        name='newPassword'
                                        value={passwordData.newPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowNewPassword(prev => !prev)}>
                                        {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>
                                
                            <div>
                                <label>: تأكيد كلمة المرور الجديدة</label>
                                <div className='bg-slate-100 p-2 flex'>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder='ادخل تاكيد كلمة المرور الجديدة '
                                        name='confirmPassword'
                                        value={passwordData.confirmPassword}
                                        onChange={handleOnChange}
                                        className='w-full h-full outline-none bg-transparent'
                                    />
                                    <div className='cursor-pointer text-xl' onClick={() => setShowConfirmPassword(prev => !prev)}>
                                        {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                                    </div>
                                </div>
                            </div>
                            {/* Forgot Password Link */}
                             <Link 
                            to={'/forgot-password'} 
                            className='block w-fit ml-auto hover:underline hover:text-red-600'
                       >
                            هل نسيت كلمة المرور؟
                            </Link>
                            <div className='flex justify-center'>
                                <button
                                    type='submit'
                                    className='flex items-center justify-center bg-blue-900 text-white px-4 py-2 text-sm shadow-md hover:bg-blue-800 transition-colors duration-300 w-[120px] text-center whitespace-nowrap'
                                    disabled={loading}
                                >
                                    {loading ? '... جاري التغيير ' : 'تغيير كلمة المرور'}
                                </button>
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </section>
    );
};

export default ChangePassword;
